import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import SessionManager from './SessionManager';

/**
 * Session Management Page
 * Standalone page for managing user sessions
 */
const SessionManagementPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <Typography variant="h4" gutterBottom>
          Session Management
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={4}>
          Manage your active sessions and security settings
        </Typography>
        
        <SessionManager 
          open={true} 
          onClose={() => {
            // Handle close - could navigate back or show different view
            window.history.back();
          }} 
        />
      </Box>
    </Container>
  );
};

export default SessionManagementPage;